import { startOfYear, subMonths, subYears } from "date-fns";
import type { ChartType } from "~types/portfolio";
import { nyTimeFormat } from "~utils/timeFormat";
import { WARDENCLYFFE_TIMESTAMP_FORMAT } from "~utils/wardenclyffe/constants";
import { CHART_TYPE_FIELD_MAP } from "~constants/Portfolio";

export default function getChartQueryArgs(chartType: ChartType) {
  const today = new Date();
  const endDate = nyTimeFormat(today, WARDENCLYFFE_TIMESTAMP_FORMAT);

  let startDate;

  switch (chartType) {
    case "1M":
      startDate = nyTimeFormat(
        subMonths(today, 1),
        WARDENCLYFFE_TIMESTAMP_FORMAT
      );
      break;
    case "6M":
      startDate = nyTimeFormat(
        subMonths(today, 6),
        WARDENCLYFFE_TIMESTAMP_FORMAT
      );
      break;
    case "YTD":
      startDate = nyTimeFormat(
        startOfYear(today),
        WARDENCLYFFE_TIMESTAMP_FORMAT
      );
      break;
    case "1Y":
      startDate = nyTimeFormat(
        subYears(today, 1),
        WARDENCLYFFE_TIMESTAMP_FORMAT
      );
      break;

    case "5Y":
      startDate = nyTimeFormat(
        subYears(today, 5),
        WARDENCLYFFE_TIMESTAMP_FORMAT
      );
      break;

    default:
      startDate = nyTimeFormat(today, WARDENCLYFFE_TIMESTAMP_FORMAT);
  }

  return {
    chartType: CHART_TYPE_FIELD_MAP[chartType],
    startDate,
    endDate,
  };
}
